var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-us full-screen" },
    [
      _c("nav", { staticClass: "navbar", attrs: { role: "navigation-demo" } }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "navbar-header" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "navbar-brand", attrs: { to: { path: "/" } } },
                [_vm._v("Tone Network")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse",
              attrs: { id: "navigation-example-2" }
            },
            [
              _c("ul", { staticClass: "nav navbar-nav navbar-right" }, [
                _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: { path: "/" } } }, [
                      _vm._v("Home")
                    ])
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("content-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navigation-example-2"
        }
      },
      [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle navigation")]),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "wrapper wrapper-full-page section content" },
      [
        _c("div", {}, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 text-center" }, [
                _c("h2", { staticClass: "title text-danger" }, [
                  _c("i", {
                    staticClass: "fa fa-exclamation-triangle px-2",
                    staticStyle: { width: "auto" }
                  }),
                  _vm._v("\n              404 Not Found\n            ")
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "title" }, [
                  _vm._v("Oops! It seems that this page does not exist.")
                ])
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-208ae547", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-208ae547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeneralViews/NotFoundPage.vue
// module id = UoOI
// module chunks = 0